module.exports = __webpack_public_path__ + "r-v3/img/sticker_6.c4a36387.svg";